import _isEqual from "lodash-es/isEqual";

export function hasSameVariants(variantsA, variantsB) {
  if (!variantsA?.length && !variantsB?.length) {
    return true;
  }

  return _isEqual(variantsA, variantsB);
}
